<template>
  <div class="participante-datos">
    <b-row>
      <b-col cols="12" xl="12">  
        <b-card header="Participante">
          <b-form>
            <b-form-group
              label="Etapa"
              label-for="etapaNombre"
              :label-cols="labelCols"
              horizontal>
              <b-input-group>
                <b-form-input 
                  id="etapaNombre"
                  :value="etapaNombre" 
                  type="text"
                  readonly>
                </b-form-input>
              </b-input-group>
            </b-form-group>

            <b-form-group
              v-if="eventoSolicitaNombre"
              label="Participante"
              label-for="nombreCompleto"
              :label-cols="labelCols"
              horizontal>
              <b-input-group>
                <b-form-input 
                  id="nombreCompleto"
                  :value="participante.nombreCompleto" 
                  type="text"
                  readonly>
                </b-form-input>
              </b-input-group>
            </b-form-group>

            <b-form-group
              v-if="participacionNegocios"
              label="Nombre Comercial"
              label-for="nombreComercial"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="nombreComercial"
                :value="participante.negocio.nombreComercial" 
                type="text"
                readonly/>
            </b-form-group>

            <b-form-group
              v-if="participacionNegocios"
              label="Razón Social"
              label-for="razonSocial"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="razonSocial"
                :value="participante.negocio.razonSocial" 
                type="text"
                readonly/>
            </b-form-group>

            <b-form-group
              v-if="participacionNegocios"
              label="CUIT"
              label-for="negocioCuit"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="negocioCuit"
                :value="participante.negocio.titular" 
                type="text"
                readonly/>
            </b-form-group>
          </b-form>
        </b-card>

        <app-validaciones-participacion
          v-if="validaParticipacion"
          ref="validacionesParticipacion"
          :eventoEtapaId="eventoEtapaId">
        </app-validaciones-participacion>

        <app-transferencias 
          v-if="transferenciasPremios"
          ref="transferencias"
          :eventoEtapaId="eventoEtapaId">
        </app-transferencias>
      </b-col>
    </b-row>

    <div class="fixed-btn">
      <div class="data-goback-btn" @click.prevent="goBack">
          <i class="fa fa-undo fa-2x" aria-hidden="true"></i>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import ValidacionesParticipacion from  './ValidacionesParticipacion.vue';
import Transferencias from  './Transferencias.vue';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs'
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'participanteDatos/getField',
  mutationType: 'participanteDatos/updateField',
});

export default {
  name: 'ParticipanteDatosEtapa',
  components: {
    appValidacionesParticipacion: ValidacionesParticipacion,
    appTransferencias: Transferencias,
    appMensaje: Mensaje,
    appConfirm: Confirm
  },
  mixins: [ 
    msjModal, 
    confirmModal
  ],
  data: () => {
    return {
      eventoEtapaId: 0,

      labelCols: 2,
    }
  },
  computed: {
    ...mapFields([
      'eventoId',
      'participanteId',

      'evento',
      'participante',
      
      'validacionesParticipacion',
      'transferencias',

      // 'participacionValidada',
    ]),
    etapaNombre() {
      if (this.evento) {
        if (this.evento.etapas) {
          let etapa = this.evento.etapas.find(etapa => etapa.id == this.eventoEtapaId);
          if (etapa) {
            return etapa.nombre;
          }
        }
      }

      return null;
    },
    validaParticipacion() {
      if (this.evento) {
        return (/true/i).test(this.evento.validaParticipacion);
      }

      return false;
    },
    transferenciasPremios() {
      if (this.evento) {
        return (/true/i).test(this.evento.transferenciasPremios);
      }

      return false;
    },
    participacionNegocios() {
      if (this.evento) {
        return (/true/i).test(this.evento.participacionNegocios);
      }

      return false;
    },
    eventoSolicitaNombre () {
      if (this.evento) {
        return (/true/i).test(this.evento.solicitaNombre);
      }
      return false;
    },

    /* Transferencias de la etapa */
    transferenciasEtapa() {
      if (this.transferencias) {
        if (this.transferencias.length != 0) {
          return this.transferencias.filter(transferencia => transferencia.eventoEtapaId == this.eventoEtapaId);
        }
      }
      return null
    }
  },
  created() {
    if (this.$route.params){
      if (this.$route.params.eventoEtapaId){
        this.eventoEtapaId = this.$route.params.eventoEtapaId;
      }
    }
  },  
  methods: {
    goBack() {
      this.$router.go(-1);
    }
  },
  watch: {
  }   
}
</script>

<style>
</style>